import { decodeLdsDealPayload } from "./orders/decodeLdsDealPayload";

const BOARD_CODE_TO_HE = {
  AI: "הכל כלול",
  BB: "ארוחת בוקר",
  HB: "חצי פנסיון",
  FB: "פנסיון מלא",
  RO: "לינה בלבד",
};

function pickFirstNonEmpty(values) {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return "";
}

function normalizeBoardCode(raw) {
  const text = String(raw || "").trim();
  if (!text) return "";
  const upper = text.toUpperCase();
  if (BOARD_CODE_TO_HE[upper]) return upper;
  const lastToken = upper.split(/\s+/).pop();
  if (BOARD_CODE_TO_HE[lastToken]) return lastToken;
  return "";
}

function normalizeBoardLabel(raw) {
  const text = String(raw || "").trim();
  if (!text) return "";
  const code = normalizeBoardCode(text);
  return code ? BOARD_CODE_TO_HE[code] : text;
}

function extractBoardCandidate(sourceName, sourceObj) {
  if (!sourceObj || typeof sourceObj !== "object") return null;
  const raw = pickFirstNonEmpty([
    sourceObj.boardBasis,
    sourceObj.board_basis,
    sourceObj.basis,
    sourceObj.mealPlan,
    sourceObj.pension,
    sourceObj.accommodationBasis,
    sourceObj.roomBasis,
    sourceObj.board,
  ]);
  if (!raw) return null;
  const code = normalizeBoardCode(raw);
  return {
    source: sourceName,
    raw,
    boardCode: code || "",
    boardLabel: normalizeBoardLabel(raw),
  };
}

function extractBoardFromDealPayload(sourceName, encoded) {
  const decoded = decodeLdsDealPayload(encoded);
  if (!decoded) return null;
  const raw = pickFirstNonEmpty([decoded.hotelBoard, decoded.board, decoded.basis]);
  if (!raw) return null;
  const code = normalizeBoardCode(raw);
  return {
    source: sourceName,
    raw,
    boardCode: code || "",
    boardLabel: normalizeBoardLabel(raw),
  };
}

export function resolveBoardBasisForPackageSummary(
  orderData,
  packageData,
  selectedRoom
) {
  const candidates = [
    extractBoardCandidate("orderData.root", orderData),
    extractBoardCandidate("orderData.hotel", orderData?.hotel),
    extractBoardCandidate(
      "orderData.reservation.hotel",
      orderData?.order_response?.reservation?.hotel
    ),
    extractBoardCandidate("selectedRoom", selectedRoom),
    extractBoardCandidate("packageData.root", packageData),
    extractBoardCandidate("packageData.hotel", packageData?.hotel),
    extractBoardCandidate("orderData.passengersinfo[0].room", orderData?.passengersinfo?.[0]?.room),
    extractBoardFromDealPayload("orderData.linkedflights.ldsDealId", orderData?.linkedflights?.ldsDealId),
    extractBoardFromDealPayload("orderData.linkedFlights.ldsDealId", orderData?.linkedFlights?.ldsDealId),
    extractBoardFromDealPayload(
      "orderData.passengersinfo[0].room.ldsDealId",
      orderData?.passengersinfo?.[0]?.room?.ldsDealId
    ),
    extractBoardFromDealPayload("orderData.extended[0].ldsDealId", orderData?.extended?.[0]?.ldsDealId),
    extractBoardFromDealPayload("packageData.linkedFlights.ldsDealId", packageData?.linkedFlights?.ldsDealId),
  ].filter(Boolean);

  const resolved = candidates[0] || null;
  if (!resolved) {
    return {
      boardCode: "",
      boardLabel: "—",
      raw: "",
      source: "missing",
      hasBoard: false,
    };
  }
  return {
    ...resolved,
    hasBoard: !!resolved.boardLabel,
  };
}

